import React from 'react'
import './previewFrame.css'

class PreviewPage extends React.Component {
    constructor(props) {
        super(props)
    }

    replaceContent = (content)=> {
        if (content !== null) {
            return content.replace(/\n/g,'sdfdsf')
        }
        return ''

    };

    render() {
        return (
            <div className='div_mainFrame'>
                <div className='content_frame'>
                        <p className='content_preview_style'>
                            {this.props.content}
                        </p>
                </div>
            </div>
        );
    }
}

export default PreviewPage;